<script setup lang="ts">
import { useUserStore } from "@/PC/store/userStore"
import { auth } from "@/common/helpers/auth"
import { auth as firebaseAuth } from "@/common/helpers/firebase"
import { signOut } from "firebase/auth"
import { storeToRefs } from "pinia"
import RegistrationModal from "./RegistrationModal.vue"

const userStore = useUserStore()
const { isLoggedIn, isCalendarScopeAuthorized } = storeToRefs(userStore)

const logout = () => signOut(firebaseAuth)
</script>

<template>
  <div class="show-my-schedule">
    <template v-if="isLoggedIn">
      <div v-if="isCalendarScopeAuthorized" class="calendar-linked-wrapper">
        <div class="calendar-linked">
          <img v-if="userStore.userIcon" :src="userStore.userIcon" class="calendar-linked-icon" />
          <sup-label class="calendar-linked-label">連携中</sup-label>
        </div>
        <div class="calendar-linked-tooltip">
          <div class="calendar-linked-tooltip-inner">
            <a href="https://nitte.app/settings/account" target="_blank">アカウント設定</a>> 連携中のアカウントで選択しているカレンダーの予定が反映されます。
            <span class="tooltip-logout" @click="logout">ログアウト</span>
          </div>
        </div>
      </div>
      <div v-else>
        ⚠️ カレンダーへのアクセス権限が許可されていないため、予定を表示できません。
        <a @click.prevent="auth">許可する</a>
      </div>
    </template>
    <registration-modal v-else>
      <div class="show-my-schedule-link">
        <a>自分の予定を表示する</a>
      </div>
    </registration-modal>
  </div>
</template>

<style scoped>
.show-my-schedule {
  display: inline-flex;
}
.show-my-schedule-link {
  display: inline-flex;
}
.calendar-linked-wrapper {
  position: relative;
}
.calendar-linked-wrapper:hover .calendar-linked-tooltip {
  display: block;
}
.calendar-linked {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.calendar-linked-tooltip {
  display: none;
  position: absolute;
  bottom: calc(100% - 4px);
  right: 0;
  padding-bottom: 8px;
  font-size: 11px;
  color: var(--font-gray-2);
  line-height: 1.5;
  white-space: nowrap;
  z-index: 200;
}
.calendar-linked-tooltip-inner {
  background: white;
  border: 0.5px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
}
.calendar-linked-tooltip a {
  color: var(--link);
}
.tooltip-logout {
  margin-left: 8px;
  color: var(--font-gray-3);
  cursor: pointer;
  text-decoration: underline;
}
.tooltip-logout:hover {
  color: var(--error);
}
.calendar-linked-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.calendar-linked-label {
  color: var(--main);
  font-weight: 600;
}
</style>
